module.exports = __webpack_public_path__ + "static/media/3.673727a6.svg";